module.exports = __webpack_public_path__ + "static/media/reports_rollover-report.e936ff47.svg";